import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authenticationActions from '../../redux/actions/AuthenticationActions';

import SplitPageContainer from '../commonComponents/shared/SplitPageContainer';
import LoadingSpinner from '../commonComponents/util/LoadingSpinner';
import FadeoutErrorMessage from '../commonComponents/util/FadeOutErrorMessage';

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: ""
        };

        this.onChange = this.onChange.bind(this);
        this.login = this.login.bind(this);
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    async login() {
        if(!this.state.username || !this.state.password) return;
        
        await this.props.actions.login(this.state.username, this.state.password);

        if (this.props.success) {
            if (this.props.data.verify) {
                (this.props.location.state && this.props.location.state.from)
                    ? this.props.history.replace("/verify-login", { from: this.props.location.state.from })
                    : this.props.history.push("/verify-login");
            } else {
                (this.props.location.state && this.props.location.state.from)
                    ? this.props.history.replace(this.props.location.state.from)
                    : this.props.history.push("/applications");
            }
        } else {
            this.setState({ password: "" });
        }
    }

    render() {
        return (
            <SplitPageContainer
                title="SFTF"
                subtitle="Log in to access your account">
                <div>
                    {(this.props.location.state && this.props.location.state.resetPasswordRedirect) &&
                        <span className="success-label success-label-margin-bottom">Your password has been reset.  Please log in below.</span>}
                    <div>
                        <label className="input-label">Email</label>
                        <input type="text" name="username" value={this.state.username} onChange={this.onChange} 
                            onKeyDown={e => { if (e.key === 'Enter') this.login() }} />
                    </div>
                    <div>
                        <label className="input-label">Password</label>
                        <input type="password" name="password" value={this.state.password} onChange={this.onChange} 
                            onKeyDown={e => { if (e.key === 'Enter') this.login() }} />
                    </div>
                    <div className="left-column-footer relative">
                        {this.props.loading ? <LoadingSpinner height="32" /> :
                            <button className="btn btn-primary btn-wide" onClick={this.login}
                                disabled={!this.state.username || !this.state.password}>Login</button>}

                        <FadeoutErrorMessage show={!this.props.success} message={this.props.message} />

                        <Link className="link-text" to={'/recover-password'}>Forgot your password? </Link>
                    </div>
                </div>
            </SplitPageContainer>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state.authentication.login
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(authenticationActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/authenticationComponents/LoginPage.jsx